import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * Fluent 2 Textarea Component
 * https://fluent2.microsoft.design/components/web/react/core/field/usage
 */
export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
  success?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, success, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Base styles
          'flex min-h-[80px] w-full rounded-md border bg-white px-3 py-2 text-sm transition-colors',
          'placeholder:text-neutral-500 dark:placeholder:text-neutral-400',
          'focus:outline-none focus:ring-2 focus:ring-offset-0',
          'disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-400',
          'dark:bg-neutral-900 dark:disabled:bg-neutral-800 dark:disabled:text-neutral-500',
          // State variants
          error
            ? 'border-[#c50f1f] focus:ring-[#c50f1f] dark:border-[#dc626d] dark:focus:ring-[#dc626d]'
            : success
              ? 'border-[#0e7a0d] focus:ring-[#0e7a0d] dark:border-[#54b054] dark:focus:ring-[#54b054]'
              : 'border-neutral-300 hover:border-neutral-400 focus:ring-[#0c00ff] focus:border-transparent dark:border-neutral-600 dark:hover:border-neutral-500 dark:focus:ring-[#479ef5]',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = 'Textarea'

export { Textarea }